/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FieldInfo } from './FieldInfo';
import {
    FieldInfoFromJSON,
    FieldInfoFromJSONTyped,
    FieldInfoToJSON,
} from './FieldInfo';

/**
 * 
 * @export
 * @interface FcbExportDetailDto
 */
export interface FcbExportDetailDto {
    /**
     * 
     * @type {Array<FieldInfo>}
     * @memberof FcbExportDetailDto
     */
    parameters?: Array<FieldInfo> | null;
}

/**
 * Check if a given object implements the FcbExportDetailDto interface.
 */
export function instanceOfFcbExportDetailDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbExportDetailDtoFromJSON(json: any): FcbExportDetailDto {
    return FcbExportDetailDtoFromJSONTyped(json, false);
}

export function FcbExportDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbExportDetailDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parameters': !exists(json, 'parameters') ? undefined : (json['parameters'] === null ? null : (json['parameters'] as Array<any>).map(FieldInfoFromJSON)),
    };
}

export function FcbExportDetailDtoToJSON(value?: FcbExportDetailDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parameters': value.parameters === undefined ? undefined : (value.parameters === null ? null : (value.parameters as Array<any>).map(FieldInfoToJSON)),
    };
}

